module.exports = __webpack_public_path__ + "static/media/yellowDart.6f445dd2.svg";